import React from 'react';
import { DatePicker, Form, Input, Modal, Spin } from 'antd';
import { DOCUMENT_UI_DATETIME_FORMAT } from '../../../../utils/documentUiFormat';
import { CLOSING_PACKAGE_MODAL_TITLES } from '../../workspace/closingPackageModalKinds';
import { usePrepareOriginalsModal } from '../../hooks/usePrepareOriginalsModal';
import ClosingPackageTaskModalContext from './ClosingPackageTaskModalContext';
import ClosingPackageTaskModalEventDateHint from './ClosingPackageTaskModalEventDateHint';
import ClosingPackageTaskModalFooter from './ClosingPackageTaskModalFooter';
import type { ClosingPackageTaskModalBaseProps } from './ClosingPackageFormationModal.types';

export type ClosingPackagePrepareOriginalsModalProps = ClosingPackageTaskModalBaseProps & {
  onSuccess?: () => void | Promise<void>;
};

/**
 * IMP-001H-5A — PREPARE_ORIGINALS workspace modal (paper originals preparation).
 */
const ClosingPackagePrepareOriginalsModal: React.FC<ClosingPackagePrepareOriginalsModalProps> = ({
  open,
  onClose,
  applicationId,
  onSuccess,
}) => {
  const { form, projection, contextView, contextLoading, submitting, handleSubmit } =
    usePrepareOriginalsModal({
      applicationId,
      open,
      onClose,
      onSuccess,
    });

  return (
    <Modal
      title={CLOSING_PACKAGE_MODAL_TITLES['prepare-originals']}
      open={open}
      onCancel={onClose}
      destroyOnClose
      width={760}
      data-testid="prepare-originals-modal"
      footer={
        <ClosingPackageTaskModalFooter
          onClose={onClose}
          onSubmit={handleSubmit}
          submitting={submitting}
          submitLabel="Подтвердить подготовку"
          submitTestId="prepare-originals-submit"
        />
      }
    >
      {contextLoading || !projection ? (
        <div style={{ textAlign: 'center', padding: 32 }}>
          <Spin />
        </div>
      ) : (
        <>
          <ClosingPackageTaskModalContext contextView={contextView} />

          <Form form={form} layout="vertical">
            <Form.Item
              name="preparedAt"
              label="Дата подготовки"
              rules={[{ required: true, message: 'Укажите дату подготовки' }]}
            >
              <DatePicker
                showTime
                style={{ width: '100%' }}
                data-testid="prepare-originals-date"
                format={DOCUMENT_UI_DATETIME_FORMAT}
              />
            </Form.Item>

            <Form.Item name="comment" label="Комментарий">
              <Input.TextArea
                rows={3}
                maxLength={500}
                showCount
                placeholder="Комментарий для журнала комплекта (необязательно)"
                data-testid="prepare-originals-comment"
              />
            </Form.Item>
          </Form>

          <ClosingPackageTaskModalEventDateHint />
        </>
      )}
    </Modal>
  );
};

export default ClosingPackagePrepareOriginalsModal;
